import { useEffect, useState, FC } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import ja from 'date-fns/locale/ja';
import 'react-datepicker/dist/react-datepicker.css';

import styles from './ZeusDatePicker.module.css';
import './ZeusDatePicker.css';

registerLocale('ja', ja);

type Props = {
  initialDate?: Date | null;
  onChange: (date: Date | null) => void;
};

export const ZeusDatePicker: FC<Props> = ({ initialDate, onChange }) => {
  const LOCALE = 'ja';
  const DATE_FORMAT = 'yyyy-MM-dd';

  const [date, setDate] = useState<Date | null>(initialDate || null);

  useEffect(() => {
    onChange(date);
  }, [date, onChange]);

  return (
    <div className={styles['date-pickers']}>
      <div>
        <DatePicker
          locale={LOCALE}
          dateFormat={DATE_FORMAT}
          selected={date}
          onChange={(_date) => setDate(_date)}
          isClearable
        />
      </div>
    </div>
  );
};
